var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PButton',{attrs:{"loading":_vm.isClearing},on:{"click":_vm.onClick}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$tk('GlobalCaching.EmptyCache'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }